import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import calls from "apis/calls";

function CreatePasswordForm() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  // const onchangHandler = (e) => {
  //   setPassword(e.target.value);
  // };
  const onsubmitHandler = (event) => {
    event.preventDefault();
    if (password.length === 0) {
      return;
    }
    calls.savePassword(password);
    navigate("/secrete-recovery-phase");
  };
  const show = async () => {
    console.log(await calls.getPassword());
  };
  show();
  return (
    <div className="box">
      {" "}
      <Form onSubmit={onsubmitHandler}>
        <Form.Group className="mb-3" controlId="formBasicPassword">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Create your Password"
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="formBasicPassword">
          <Form.Label>Confirm Password</Form.Label>
          <Form.Control
            type="password"
            requierd
            placeholder="Confirm Your Password"
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicCheckbox">
          <Form.Check type="checkbox" label="Check me out" />
        </Form.Group>
        <div className="send-btn mt-5">
          <button type="submit" className="btn w-100">
            <span> Create Wallet </span>
          </button>
        </div>
      </Form>
    </div>
  );
}

export default CreatePasswordForm;
